<div class="material-theme-login">
  <module-container [customStyle]="{ 'margin-top': 0, padding: '0.8vw' }">
    <div class="controller-container">
      <div *ngIf="currentInputDocument == undefined">
        <button mat-raised-button color="accent" (click)="getNextFile()" [disabled]="isloading">
          Start Job
        </button>
      </div>
      <div *ngIf="currentInputDocument != undefined">
        <button mat-raised-button color="warn" (click)="releaseFile()" [disabled]="isloading">
          Stop Job
        </button>
      </div>
      <div class="job-title-container">
        <span>Rescan Job</span>
      </div>
    </div>
  </module-container>
</div>

<div *ngIf="currentInputDocument != undefined" class="job-container material-theme-login">
  <div [style.width]="pdfWidth == null ? '100%' : pdfWidth + 'px'" class="file-container">
    <module-container type="full-height">
      <pdf-viewer
        [uuid]="currentInputDocument.uuid"
        (pdfWidth)="changePdfWidth($event)"
      ></pdf-viewer>
    </module-container>
  </div>
  <div class="form-container">
    <module-container>
      <form class="rescan-form">
        Document Review
        <mat-divider></mat-divider>
        <mat-form-field appearance="fill">
          <mat-label>Document Number</mat-label>
          <input matInput name="documentNumber" [formControl]="documentNumValue" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Supplier</mat-label>
          <input matInput name="Supplier" [formControl]="selectedSupplier" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Reason</mat-label>
          <mat-select name="reason" [formControl]="reason">
            <mat-option ngClass="selectFormOption" value="Poor quality">Poor quality</mat-option>
            <mat-option ngClass="selectFormOption" value="Multiple invoices in one scan"
              >Multiple invoices in one scan</mat-option
            >
            <mat-option ngClass="selectFormOption" value="General invoice"
              >General invoice</mat-option
            >
            <mat-option ngClass="selectFormOption" value="Credit note - not completed in full"
              >Credit note - not completed in full</mat-option
            >
            <mat-option ngClass="selectFormOption" value="Other reason">Other reason</mat-option>
            <mat-option ngClass="selectFormOption" value="Missing Pages">Missing Pages</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Comment</mat-label>
          <textarea matInput rows="5" name="comment" [formControl]="comment"></textarea>
        </mat-form-field>
        <button
          mat-raised-button
          color="accent"
          (click)="onRequestRescanClick()"
          [disabled]="isloading"
        >
          Request Rescan
        </button>
      </form>
    </module-container>

    <div class="floating-button-container">
      <module-container>
        <div class="button-container">
          <button mat-stroked-button (click)="onRestoreClick()" [disabled]="isloading">
            Restore
          </button>
          <button mat-stroked-button (click)="onAllocateClick()" [disabled]="isloading">
            Allocate
          </button>
        </div>
      </module-container>
    </div>
  </div>
</div>
